module.exports = __webpack_public_path__ + "img/porduct_index.861806b8.png";